// extracted by mini-css-extract-plugin
export default {"card":"retreatPage_card__9LYuR","contents":"retreatPage_contents__tu5gt","tags":"retreatPage_tags__hjF77","description":"retreatPage_description__4eW+Q"};